import { Visit, VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';
import {
   PatientContinuouslyUsedMedicine,
   PatientMedicine,
   PatientReimbursement,
} from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';
import { ServiceLocationId } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { Address } from '@dreryk/address-common-api';

export type VisitInterviewPath = string;
export type VisitId = Visit['id'];
export type PatientId = Patient['id'];
export type PrescriptionReadOnly = boolean;

export type OnMedicineSelection = (
   selectedPatientMedicine: PatientMedicine,
   selectedPatientReimbursement?: PatientReimbursement
) => void;

export type OnContinuouslyUsedMedicineSelection = (
   selectedPatientMedicine: PatientMedicine,
   selectedPatientContinuouslyUsedMedicine: PatientContinuouslyUsedMedicine
) => void;

export type CreateInvalidateVisitAction = () => void;

export type PrescriptionIssuingPanelProps = {
   visitId: VisitId;
   visitDiagnoses: VisitDiagnosis[];
   patientId: PatientId;
   patientAddress: Address | undefined;
   patientReferenceIdentifier: PatientReferenceIdentifier;
   locationId: ServiceLocationId;
   appointmentId: Visit['appointmentId'];
   inPersonExaminationPerformed: boolean;
   documentationScope: Visit['documentationScope'];
};

export enum PrescriptionPanelNavParams {
   DOWNLOAD_HISTORY = 'pobierz-historie',
   PRESCRIPTION_HISTORY = 'historia-recept',
   CONTINUOUSLY_USED_MEDICINES = 'leki-stale',
   FAVORITE_MEDICINES = 'leki-ulubione',
}
